@if (forecast(); as forecast) {
  @if (forecast.company; as company) {
    <!-- TODO: Remove duplicate styles  -->
    <!-- <app-user-section-access [sectionName]="guardSection()">
    <ng-template> -->
    <div class="forecast-wrapper">
      <app-stock-price-predictions-info
        class="forecast-info"
        [forecast]="forecast"
        [guardSectionName]="routerFacade.guardSectionName$ | async"
      ></app-stock-price-predictions-info>

      <section class="chart-card">
        <div class="chart-wrapper">
          @if (contourChartComponent(); as contourChartComponent) {
            <div class="chart">
              <ng-container
                *ngComponentOutlet="
                  contourChartComponent | async;
                  inputs: {
                    ticker: company.ticker,
                    sectionName: guardEpsContourChart(),
                    title: 'chart.isolineChart.epsContourChart.title' | translate,
                  }
                "
              />
            </div>
          } @else {
            <app-loading class="loading"></app-loading>
          }

          @if (impactIsolinesChartComponent(); as impactIsolinesChartComponent) {
            <div class="chart">
              <ng-container
                *ngComponentOutlet="
                  impactIsolinesChartComponent | async;
                  inputs: {
                    ticker: company.ticker,
                    sectionName: guardImpactIsoLinesChart(),
                    title: 'chart.isolineChart.epsIsolineChart.title' | translate,
                  }
                "
              />
            </div>
          } @else {
            <app-loading class="loading"></app-loading>
          }
        </div>
      </section>
    </div>
    <!-- </ng-template>
  </app-user-section-access> -->
  }
}
